// =====================================================
// 📂 event_types.js
//
// Central list of supported event types.
//
// Used by:
// - Event Request Form
// - Event Creation/Edit
// - Demo Event Generator
// - Prospects
// - Future Industry Landing Pages
// =====================================================

export const EVENT_TYPES = [
  {
    value: "car_show",
    label: "🚗 Car Show",
  },
  {
    value: "art_show",
    label: "🎨 Art Show",
  },
  {
    value: "pet_show",
    label: "🐶 Pet Show",
  },
  {
    value: "school_election",
    label: "🗳️ School Election",
  },
  {
    value: "silent_auction",
    label: "🏷️ Silent Auction",
  },
  {
    value: "fundraiser",
    label: "💰 Fundraiser",
  },
  {
    value: "festival",
    label: "🎪 Festival or Fair",
  },
  {
    value: "nonprofit",
    label: "🤝 Nonprofit Event",
  },
  {
    value: "other",
    label: "📌 Other",
  },
];

export const getEventTypeLabel = (value) => {
  return (
    EVENT_TYPES.find((type) => type.value === value)?.label ||
    "📌 Other"
  );
};
